import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=2e7c9fb4"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"
import style0 from "./MyPlan.vue?vue&type=style&index=0&id=2e7c9fb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports